<template>
  <div class="view">

  <div class="filterbtns">
    <template v-for="(v,i) in filter_areas">
      <filterbtn :active="(filter_area==v)" @click.native="filter_area=filter_areas[i]">{{v}}</filterbtn>
    </template>
  </div>

  <template v-if="filter_area=='boxes'">

    <box label="Basic box">
      Basic box
    </box>

    <box label="Basic box, meta content">
      <template slot="meta-r">
        [Meta-r]
        <span class="textlink">Link</span>
        <span class="textlink">Link</span>
      </template>
      Basic box, meta content
    </box>

    <box label="box-ception" :open="boxOpenStatus1" @toggledOpen="flipBoolean('boxOpenStatus1')">
      <box label="box-ception" :open="boxOpenStatus2" @toggledOpen="flipBoolean('boxOpenStatus2')">
        <box label="box-ception" :open="boxOpenStatus3" @toggledOpen="flipBoolean('boxOpenStatus3')">
          open status handled with var and var update
        </box>
      </box>
    </box>

    <box label="open = static non-var true" :open="true">
      open = static non-var true
    </box>

    <box label="open = static non-var false" :open="false">
      open = static non-var false
    </box>

    <box label="Full header toggle-able" :open="false" header-toggle>
      Lorem ipsum dolor amet si
    </box>

    <box label="Only one box visible at a time" :open="true">
      <box label="Box 1" :open="boxOpenStatus_a1" @toggledOpen="setOnlyOneTrue(0,['boxOpenStatus_a1','boxOpenStatus_a2','boxOpenStatus_a3'])">
        Box 1
      </box>
      <box label="Box 2 (full header togglable)" :open="boxOpenStatus_a2" header-toggle @toggledOpen="setOnlyOneTrue(1,['boxOpenStatus_a1','boxOpenStatus_a2','boxOpenStatus_a3'])">
        Box 2
      </box>
      <box label="Box 3" :open="boxOpenStatus_a3" @toggledOpen="setOnlyOneTrue(2,['boxOpenStatus_a1','boxOpenStatus_a2','boxOpenStatus_a3'])">
        Box 3
      </box>
    </box>



  </template>
  <template v-if="filter_area=='tabs'">

    <box label="Tabs">
      <tabs :active-tab="tabs1_activeIndex">
        <tab label="First tab">
            This is the content of the first tab
        </tab>
        <tab label="Second tab">
            This is the content of the second tab
        </tab>
        <tab label="Custom fragment">
            The fragment that is appended to the url can be customized
        </tab>
        <tab prefix="X<span class='glyphicon glyphicon-star'></span>X "
             label="Prefix and suffix"
             suffix=" Y<span class='badge'>4</span>Y">
            A prefix and a suffix can be added
        </tab>
      </tabs>
    </box>

    <tabs look="boxed" :active-tab="tabs1_activeIndex">
      <tab label="First tab">
          This is the content of the first tab
      </tab>
      <tab label="Second tab">

        <tabs look="boxed" :active-tab="tabs1_activeIndex">
          <tab label="First tab">
              This is the content of the first tab
          </tab>
          <tab label="Second tab">
              This is the content of the second tab
          </tab>
          <tab prefix="X<span class='glyphicon glyphicon-star'></span>X "
               label="Prefix and suffix"
               suffix=" Y<span class='badge'>4</span>Y">
              A prefix and a suffix can be added
          </tab>
        </tabs>

      </tab>
      <tab prefix="X<span class='glyphicon glyphicon-star'></span>X "
           label="Prefix and suffix"
           suffix=" Y<span class='badge'>4</span>Y">
          A prefix and a suffix can be added
      </tab>
    </tabs>


    <TabBoxes :tabs="[{label:'tab1'},{label:'tab2'}]">
      <template slot="tab1">Tab 1 her</template>
      <template slot="tab2">Tab 2 her</template>
    </TabBoxes>


  </template>
  <template v-if="filter_area=='buttons'">

    <btn>Btn color1</btn>
    <btn color="primary">Btn primary</btn>
    <btn color="secondary">Btn secondary</btn>
    <btn color="tertiary">Btn tertiary</btn>
    <btn color="danger">Btn danger</btn>
    <btn color="warning">Btn warning</btn>
    <btn color="success">Btn success</btn>
    <btn color="primary" disabled>Btn disabled</btn>

    <br><br>

    <box label="Large and small">
      <btn color="primary" large>Large</btn>
      <btn color="primary">Normal</btn>
      <btn color="primary" small>Small</btn>
    </box>

    <br><br>

    <div class="filterbtns">
      <template v-for="i in 3">
        <filterbtn >Filterbtn</filterbtn>
      </template>
      <filterbtn active="true">Filterbtn</filterbtn>
    </div>

    <br><br>

    <btn icon-r="Y">Button</btn>
	  <btn icon-l="X" color="secondary">Button</btn>
	  <btn icon-r=Haay"" icon-l="X" color="secondary">Button</btn>

  </template>
  <template v-if="filter_area=='interactions'">


  	<box label="Interactions">

  		<btn @click.native="triggerToast()">Trigger toast</btn>

  	</box>

  </template>
  <template v-if="filter_area=='inputs'">

    <box label="Checkboxes">

      <div class="checkbox">
        <input type="checkbox" v-model="checkboxey12" id="kj12b3kj">
        <label for="kj12b3kj">Label</label>
      </div>

      <div class="checkbox">
        <input type="checkbox" v-model="checkboxey12" id="kjh123">
        <label for="kjh123">Label</label>
      </div>      

    </box>

    <box>
      
      <inputfield _label="Timer" suffix="timer">
        <input type="number" min="0.25" max="3" step="0.25" class="number-btns" placeholder="0">
      </inputfield>

      <br>
      
      <inputfield label="Timer" suffix="xxx">
        <input type="number" min="0.25" max="3" step="0.25" class="number-btns" placeholder="0">
      </inputfield>

      <br>

      <inputfield label="Select box">
          <select>
            <option value="undefined">Vælg...</option>
            <option value="a">A</option>
            <option value="b">B</option>            
            <option value="c">C</option>            
          </select>
          <div class="select-arrow">▾</div>
        </inputfield>

        <br>

        <inputfield label="Med ikon" icon="linearicons/arrow-left">
          <input type="text">
        </inputfield>

        <br>

        <inputfield label="Med ikon" icon="linearicons/alarm">
          <input type="text">
        </inputfield>
      
    </box>


  </template>
  <template v-if="filter_area=='whatever'">

    <box>
      <minidonut :pct="22" :color="'white'" :bgcolor="'rgba(255,255,255,.3)'"></minidonut>
      <minipctbar :pct="52" :color="'white'" :bgcolor="'rgba(255,255,255,.3)'"></minipctbar>
      <minidonut :pct="36"></minidonut>
      <minipctbar :pct="73"></minipctbar>
    </box>

    <!--<ui-tabs type="text">
        <ui-tab title="Books">
            My books
        </ui-tab>

        <ui-tab title="Authors">
            Authors
        </ui-tab>

        <ui-tab title="Collections">
            My collections
        </ui-tab>
    </ui-tabs>-->

    <div class="grid">
  		<div class="col m50" v-for="i in 2">
  			<box label="Box">Box</box>
  		</div>
  	</div>

  	<div class="grid">
  		<div class="col m20" v-for="i in 5">
  			<box label="Box">Box</box>
  		</div>
  	</div>

  	<div class="grid">
  		<div class="col m10" v-for="i in 10">
  			<box label="Box">Box</box>
  		</div>
  	</div>

  	<p>Global data: Appname: {{globals.name}}, {{globals.count}} -
  		<span @click="incrementGlobalCount()">{{globals.count}}</span>
  	</p>

  	<box label="Trend charts">

  		<trend
  		  :data="[0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0]"
  		  :gradient="['#6fa8dc', '#42b983', '#2c3e50']"
  		  auto-draw
  		  smooth>
  		</trend>

  	</box>

  	<box label="Boxlabel">
  		<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
  		<btn>Buttoner</btn>
  	</box>

  	<box label="label here, yo">
  		Yo, box indhold
  		<btn>Yiffy</btn>
  		<btn>Yallo</btn>
  	</box>

    <box label="element-ui">

    </box>

  	<box label="Vue stuff to implement">

  		<p>Generic UI USE THIS !!!: https://josephuspaye.github.io/Keen-UI/#/ui-tabs</p>
  		<p>Brug alt herfra, navnligt select</p>

  		<p>Tooltips</p>
  		<p>Alert/confirm/prompts</p>
  		<p>Datatables: filter, pagination, sort, perpage</p>
  		<p>https://github.com/surmon-china/vue-awesome-swiper</p>
  		<p>Charts</p>
  		<p>time/Date/calendarpicker</p>
  		<p>Avatars</p>
  		<p>Trello kanban: https://github.com/BrockReece/vue-kanban</p>
  		<p>Wysiwyg</p>
  		<p>Selectiz</p>
  		<p>Colorpicker</p>


  	</box>


  </template>


  </div>
</template>

<script>
import Box from '.././components/Box'
import TabBoxes from '.././components/TabBoxes'
import TabBox from '.././components/TabBox'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
import Filterbtn from '.././components/Filterbtn'
import Minipctbar from '.././components/Minipctbar'
import Minidonut from '.././components/Minidonut'
import Tabs from '.././components/Tabs'
import Tab from '.././components/Tab'
export default {
  name: 'kitchensink',
  components: { Box, Btn, Inputfield, TabBox, TabBoxes, Filterbtn, Tabs, Tab, Minipctbar, Minidonut, },
  data: function () {
    return {
      globals: this.$parent.globals,
	    filter_areas: ['boxes','tabs','buttons','interactions','inputs','tables','whatever'],
      filter_area: 'boxes',
      colors: '#666',
      var1: 'something',
      boxOpenStatus1: true, boxOpenStatus2: true, boxOpenStatus3: true,
      boxOpenStatus_a1: true, boxOpenStatus_a2: false, boxOpenStatus_a3: false,
      tabs1_activeIndex: 2,
      tabs2_activeIndex: 1,
      checkboxey12: true,
      dummy_switchval: true,
    }
  },
  methods: {
	  triggerToast() {
		  this.$toasted.show('hello billo', {
			  position: 'bottom-right',
			  duration: '4000',
		  })
	  },
    flipBoolean(key) {
      this[key] = !this[key]
    },
    setOnlyOneTrue( target_index, target_array ) {
      if( this[ target_array[target_index] ] == true ) {
        this[ target_array[target_index] ] = false
      } else {
        for( var i in target_array ) this[ target_array[i] ] = ( i == target_index )
      }
    },
    
  },
}
</script>



// WEBPACK FOOTER //
// Kitchensink.vue?7e125780